<template>
  <div>
    <v-toolbar dark flat class="secondary headline mb-0">
      <v-toolbar-title>New Vendor</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="ml-4" dark flat icon @click="closeContactDialog"><v-icon>cancel</v-icon></v-btn>
    </v-toolbar>
    <v-container style="background-color:white">
      <!-- Contact Form -->
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-text-field v-model="vendor.company_name" :rules="nameRules" :counter="30" label="Company Name (Vendor Name)" required prepend-icon="assignment_ind"></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-layout row>
                  <v-select v-model="vendor.vendor_type" :rules="selectRequired" :items="vendorTypes" label="Vendor Type" required multiple chip prepend-icon="account_circle"></v-select>
                  <v-btn flat icon @click="editDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
                </v-layout>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="vendor.phone" name="phone" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                  <v-text-field v-model="vendor.email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
                </v-flex>
              <!-- Address Information -->
              <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="vendorAddress.address" name="address" label="Address" prepend-icon="add_location"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="vendorAddress.city" name="city" label="City" prepend-icon=" "></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="vendorAddress.state" name="state" label="State (i.e. FL)" prepend-icon=" "></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="vendorAddress.zip" name="zip" label="Zip"></v-text-field>
              </v-flex>
              </v-layout>
            </v-layout>
            <!-- Builder Contacts -->
            <template>
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                  <p class="orange white--text">Add vendor contacts{{vendor.company_name ? ' for ' + vendor.company_name +'.' : '.' }} You can add as many as needed.</p>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-text-field v-model="vendorContacts.first_name" :counter="30" label="First Name" required prepend-icon="person"></v-text-field>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-text-field v-model="vendorContacts.last_name" :counter="30" label="Last Name" required prepend-icon="person"></v-text-field>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-text-field v-model="vendorContacts.email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-text-field v-model="vendorContacts.phone" name="phone" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-chip color="indigo" text-color="white" @click="createVendorContacts()"><v-icon class="pr-3 hover">person_add</v-icon>Add Another Contact</v-chip>
                </v-flex>
              </v-layout>
              <p></p>
            </template>
            <!-- Added Builder Contacts List -->
            <v-layout row wrap>
            <v-chip v-if="vendorContactsArray.length > 0" label color="pink" text-color="white">
              <v-icon left>label</v-icon>Vendor Contacts Added:
            </v-chip>
            <template v-for="(vendor, index) in vendorContactsArray">
              <v-chip @input="removeVendorContact(index)" v-model="vendor.index" close :key="index" color="indigo" text-color="white">
                <v-avatar>
                  <v-icon>account_circle</v-icon>
                </v-avatar>
                {{ vendor.first_name }} {{ vendor.last_name }}
              </v-chip>
            </template>
            </v-layout>
          </v-container>
        </v-form>
      <v-layout row wrap>
        <v-flex>
            <v-btn :disabled="!valid" flat class="primary" @click="createVendorButton"><v-icon left>assignment_ind</v-icon>Save and Close</v-btn>
            <v-btn flat class="secondary" @click="closeContactDialog">Cancel</v-btn>
        </v-flex>
      </v-layout>
      <v-alert :value="error !== null ? true : false" color="error" icon="new_releases">An error has occured. Try again. Error details: {{ error }}</v-alert>
    </v-container>
    <!-- Edit Drop Down -->
    <v-dialog max-width="600px" v-model="editDropdownDialog">
      <edit-dropdown v-if="editDropdownDialog" dropdownName="vendorTypes" @closeDialog="editDropdownDialog = false"/>
    </v-dialog>
    <!-- End: Edit Drop Down -->
  </div>
</template>

<script>

import EditDropdown from '../../helpers/EditDropdown'

export default {
  data () {
    return {
      editDropdownDialog: false,
      valid: true,
      vendorAddress: {address: null, city: null, state: null, zip: null},
      vendor: {id: null, company_name: null, phone: null, email: null, vendor_type: null},
      vendorContacts: {first_name: null, last_name: null, email: null, phone: null, deleted: false},
      vendorContactList: {},
      vendorContactsArray: [],
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      validationRequired: [
        v => !!v || 'Field is required'
      ],
      selectRequired: [
        v => (v && v.length > 0) || 'Must select a Vendor Type'
      ],
      email: '',
      error: null,
      showValidatedButton: false,
      emailRules: [
        // v => !!v || 'E-mail is required',
        v => v ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid' : true
      ]
    }
  },
  computed: {
    vendorTypes () {
      return this.$store.getters.vendorTypes
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    closeContactDialog () {
      this.$emit('closeDialog')
    },
    createVendorButton () {
      if (this.$refs.form.validate()) {
        this.createVendorContacts()
        this.createVendor()
        this.closeContactDialog()
      }
    },
    createVendor () {
      // Set Contact Id (Timestamp)
      this.setId()
      // Include Address Information?
      if (this.vendorAddress.address || this.vendorAddress.city || this.vendorAddress.state || this.vendorAddress.zip) {
        this.vendor = {...this.vendor, ...this.vendorAddress}
      }
      this.vendor = {...this.vendor, vendor_contacts: []}
      this.vendor.vendor_contacts = this.vendorContactsArray
      this.$store.dispatch('createVendor', this.vendor)
    },
    createVendorContacts () {
      if (this.vendorContacts.first_name) {
        this.vendorContactsArray.push(this.vendorContacts)
      }
      this.vendorContacts = {first_name: null, last_name: null, email: null, phone: null, active: true, deleted: false}
    },
    removeVendorContact (index) {
      this.vendorContactsArray.splice(index, [index])
    },
    setId () {
      let milliseconds = String((new Date()).getTime())
      let timestamp = milliseconds + '-' + Math.floor(Math.random() * 100) + 10
      this.vendor.id = timestamp // Set the contact.id - forcing timestamp refresh
    }
  },
  components: {
    EditDropdown
  }
}
</script>

<style scoped>
.btn--floating.btn--small .icon {
  font-size: 30px;
}
.btn--floating.btn--small {
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/vendors/CreateVendor.vue